export default {
  en: {
    account: {
      profile: 'My Profile',
      business: 'Business',
      subscriptions: 'Subscriptions',
      administrators: 'Administrators',
      integration: 'Integration',
      webhooks: 'Events (Webhooks)',
      global: 'Miscellaneous',
      logout: 'Logout',
    },
    insights: 'Insights',
    users: 'Users',
    departments: 'Departments',
    integration: 'Integrate',
    marketplace: 'Marketplace',
    insightsMenu: {
      calls: 'Calls',
      departments: 'Departments',
      agents: 'Agents',
      history: 'History',
    },
    accounts: 'Accounts',
  },
  es: {
    account: {
      profile: 'Mi Perfil',
      business: 'Empresa',
      subscriptions: 'Suscripciones',
      administrators: 'Administradores',
      integration: 'Integración',
      webhooks: 'Eventos (Webhooks)',
      global: 'Misceláneos',
      logout: 'Cerrar sesión',
    },
    insights: 'Reportes',
    users: 'Usuarios',
    departments: 'Departamentos',
    integration: 'Integrar',
    marketplace: 'Marketplace',
    insightsMenu: {
      calls: 'Llamadas',
      departments: 'Departamentos',
      agents: 'Agentes',
      history: 'Historial',
    },
    accounts: 'Cuentas',
  },
};
